import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  isTaskDetailsLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_TASK_DETAILS_ERROR:
    case actionTypes.GET_TASK_DETAILS_SUCCESS:
      if (action.payload.type === 'SMS_AND_ISSUES') {
        return action.payload.data;
      }
      return state;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.GET_TASK_DETAILS:
          return Object.assign({}, state, { isTaskDetailsLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.GET_TASK_DETAILS:
          return Object.assign({}, state, { isTaskDetailsLoading: false });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.UNLOAD_TASK_DETAILS:
      return initialState;
    default:
      return state;
  }
}
